
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'DiagnosticCriteriaForDM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/DiagnosticCriteriaForDM.vue